import React from 'react'
import '../../../styles/Object/auth_buttons.scss'

interface Props {
  dataMnCspLocation: string
}

export const AuthButtons: React.FC<Props> = ({ dataMnCspLocation }) => {
  const medicalnoteQaPath = `https://medicalnote-qa.jp/`
  const signupPath = `/features/qa/mild_cognitive_impairment/signup`
  return (
    <div className="auth-buttons">
      <a
        className="auth-buttons__btn auth-buttons__btn-primary"
        href={signupPath}
        data-mn-csp-kind="MN会員登録"
        data-mn-csp-location={dataMnCspLocation}
      >
        <span className="auth-buttons__text-pre">無料</span>
        <span>認知症の医療相談をはじめる</span>
      </a>
      <div className="auth-buttons__text-btn-wrapper">
        <a
          className="auth-buttons__text-btn"
          href={medicalnoteQaPath}
          data-mn-csp-kind="医療相談"
          data-mn-csp-location={dataMnCspLocation}
        >
          <span>他の病気も相談したい方はこちら（有料）</span>
        </a>
      </div>

      <p className="auth-buttons__caution">
        ※「無料で認知症相談をはじめる」場合、メディカルノート・Theoria
        technologies株式会社が運営するTHEO ONEに登録されます。メディカルノートの
        <a
          className="underline"
          target="_blank"
          rel="noreferrer"
          href="https://medicalnote.jp/terms"
        >
          利用規約
        </a>
        ・
        <a
          className="underline"
          target="_blank"
          rel="noreferrer"
          href="https://medicalnote.co.jp/privacy"
        >
          プライバシーポリシー
        </a>
        およびTHEO ONEの
        <a
          className="underline"
          target="_blank"
          rel="noreferrer"
          href="https://theo-one.com/terms/terms-of-use"
        >
          利用規約
        </a>
        ・
        <a
          className="underline"
          target="_blank"
          rel="noreferrer"
          href="https://theo-one.com/terms/privacy-policy"
        >
          プライバシーポリシー
        </a>
        に同意のうえお進みください。
        <br />
        ※「有料の医療相談サービスで相談する」場合、Medical Note
        医療相談へ遷移します。
      </p>
    </div>
  )
}
